import React, { useEffect, useRef } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import {
  appConstantes,
  limitSize,
  nemonicoIdentificacion,
  nemonicoTipoSolicitud,
} from "../../constantes/appConstantes";
import { obtenerCantones, obtenerParroquias } from "../../sliceRedux/Reserva.slice";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { CounterString } from "../../componentes/CounterString";
import { obtenerNombresFecha, setNombres } from "../../sliceRedux/ValidarReserva.slice";
import { InputNumber } from "primereact/inputnumber";
import DownloadButton from "../../componentes/DownloadButton";
import { setCalendarLanguage } from "../../helpers/locale";

const RegistrarSocios = ({
  modal,
  callbackModal,
  showLoader,
  hideLoader,
  dispatch,
  toast,
  callbackSaveSocio,
  socio,
  codSolConstitucion,
  fecReunionAsamblea,
  nemTipoSolicitud,
}) => {
  const fileUploadRef = useRef(null);
  const listaPaises = useSelector((state) => state.reserva.listaPaises);
  const listaTiposVisa = useSelector((state) => state.reserva.listaTiposVisa);
  const listaProvincias = useSelector((state) => state.reserva.listaProvincias);
  const listaCantones = useSelector((state) => state.reserva.listaCantones);
  const listaParroquias = useSelector((state) => state.reserva.listaParroquias);
  const listaTiposIdentificacion = useSelector((state) => state.reserva.listaTiposIdentificacion);
  const nombres = useSelector((state) => state.validar.nombres);
  const deshabilitarCamposRepresentante = !!socio.nemCargo;
  const deshabilitarCampos = socio.codSolConstSocios || deshabilitarCamposRepresentante;
  setCalendarLanguage();
  const visaOptions =
    listaTiposVisa?.object?.map((visa) => ({
      ...visa,
      displayLabel: `${visa.nomNemonico} - ${visa.nomCatalogo}`,
    })) ?? [];

  useEffect(() => {
    let tipo = listaTiposIdentificacion?.object?.find(
      (item) => item.codCatalogo === socio.codCatTipoIdentificacion,
    );
    formik.setFieldValue("nemonicoTipoIdentificacion", tipo?.nomNemonico ?? "");

    if (
      socio.nemCargo &&
      socio.codSolConstSocios == null &&
      tipo?.nomNemonico === nemonicoIdentificacion.CEDULA
    ) {
      showLoader();
      dispatch(obtenerNombresFecha(tipo?.nomNemonico, socio.numIdentificacion));
    }

    if (socio.codSolConstSocios) {
      showLoader();
      Promise.all([
        dispatch(obtenerCantones(socio.codAmbGeoProvincia)),
        dispatch(obtenerParroquias(socio.codAmbGeoCanton)),
      ]).then(() => {
        hideLoader();
      });
    }
  }, []);

  useEffect(() => {
    hideLoader();
  }, [listaCantones]);

  useEffect(() => {
    hideLoader();
  }, [listaParroquias]);

  useEffect(() => {
    if (nombres.code === 200) {
      formik.setFieldValue("nombre", nombres?.object?.nombreCompleto ?? "");
      formik.setFieldValue(
        "fechaNacimiento",
        nombres?.object?.fecNacimiento != null
          ? moment(nombres?.object?.fecNacimiento).toDate()
          : "",
      );
      hideLoader();
    }
    return () => {
      dispatch(setNombres({ ...nombres, ...{ code: 0 } }));
    };
  }, [nombres.code]);

  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const validationSchemaEntidad = Yup.object().shape({
    nombre: Yup.string().required("Campo requerido."),
    tipoIdentificacion: Yup.string().required("Campo requerido."),
    nemonicoTipoIdentificacion: Yup.string().required("Campo requerido."),
    identificacion: Yup.string().required("Campo requerido."),
    identificacion: Yup.string().required("Campo requerido."),
    celular: Yup.string()
      .required("Campo requerido.")
      .matches(/^09\d{8}$/, "El número de celular debe empezar con 09 y tener 10 dígitos."),
    email: Yup.string()
      .email("Formato de correo electrónico no válido.")
      .required("Campo requerido."),
    fechaIngreso: Yup.string().required("Campo requerido."),
    fechaNacimiento: Yup.string().required("Campo requerido."),
    provincia: Yup.string().required("Campo requerido."),
    canton: Yup.string().required("Campo requerido."),
    parroquia: Yup.string().required("Campo requerido."),
    callePrincipal: Yup.string().required("Campo requerido."),
    calleSecundaria: Yup.string().required("Campo requerido."),
    nombreDocumento: Yup.string().required("Campo requerido."),
    aporte: Yup.number()
      .required("Campo requerido.")
      .nullable()
      .test(
        "max-digits",
        "El valor debe tener como máximo 12 enteros y 2 decimales.",
        (value) => value == null || /^\d{1,12}(\.\d{1,2})?$/.test(String(value)),
      ),
    paisEmision: Yup.string().when("nemonicoTipoIdentificacion", {
      is: (nemonico) =>
        nemTipoSolicitud === nemonicoTipoSolicitud.CONSTITUCION &&
        nemonico === nemonicoIdentificacion.PASAPORTE &&
        !!socio.nemCargo,
      then: (schema) => schema.required("Campo requerido."),
      otherwise: (schema) => schema,
    }),
    tipoVisa: Yup.string().when("nemonicoTipoIdentificacion", {
      is: (nemonico) =>
        nemTipoSolicitud === nemonicoTipoSolicitud.CONSTITUCION &&
        nemonico === nemonicoIdentificacion.PASAPORTE &&
        !!socio.nemCargo,
      then: (schema) => schema.required("Campo requerido."),
      otherwise: (schema) => schema,
    }),
  });

  const formik = useFormik({
    initialValues: {
      codSolConsSocio: socio.codSolConstSocios ?? null,
      codSolConstitucion: codSolConstitucion ?? null,
      tipoIdentificacion: socio.codCatTipoIdentificacion ?? "",
      identificacion: socio.numIdentificacion ?? "",
      celular: socio.numCelular ?? "",
      telefono: socio.numTelefono ?? "",
      nombre: socio.nombres ?? "",
      email: socio.txtEmail ?? "",
      fechaIngreso: socio.fecIngreso
        ? moment(socio.fecIngreso).toDate()
        : moment(fecReunionAsamblea).toDate(),
      fechaNacimiento: socio.fecNacimiento ? moment(socio.fecNacimiento).toDate() : "",
      provincia: socio.codAmbGeoProvincia ?? "",
      canton: socio.codAmbGeoCanton ?? "",
      parroquia: socio.codAmbGeoParroquia ?? "",
      callePrincipal: socio.nomCallePrincipal ?? "",
      calleSecundaria: socio.nomCalleSecundaria ?? "",
      numero: socio.txtNumero ?? "",
      documento: "",
      nombreDocumento: socio.nomArchivoPlanilla ?? "",
      codDocuwarePlanilla: socio.codDocuwarePlanilla ?? 0,
      aporte: socio.valAporte ?? null,
      referencia: socio.txtReferencia ?? "",
      nemCargo: socio.nemCargo ?? null,
      paisEmision: socio.codAmbGeoPais ?? "",
      tipoVisa: socio.codCatTipoVisa ?? "",
      nemonicoTipoIdentificacion: "",
      archivo: null,
      bytesDocumento: null,
    },
    validationSchema: validationSchemaEntidad,
    onSubmit: (data) => {
      let dataSend = {
        codSolConsSocio: data.codSolConsSocio,
        codSolConstitucion: data.codSolConstitucion,
        codTipoIdentificacion: data.tipoIdentificacion,
        numIdentificacion: data.identificacion,
        nombres: data.nombre,
        codProvincia: data.provincia,
        codCanton: data.canton,
        codParroquia: data.parroquia,
        valAporte: data.aporte,
        fechaIngreso: moment(data.fechaIngreso).valueOf(),
        fechaNacimiento: moment(data.fechaNacimiento).valueOf(),
        callePrincipal: data.callePrincipal,
        calleSecundaria: data.calleSecundaria,
        celular: data.celular,
        tlfFijo: data.telefono,
        email: data.email,
        txtNumero: data.numero,
        txtReferencia: data.referencia,
        nemCargo: data.nemCargo ?? null,
        codParamCargoGrupoSoc: socio?.codParamCargoGrupoSoc ?? null,
        nombrePlantilla: data.nombreDocumento,
        codTipoVisa: data.tipoVisa,
        codPais: data.paisEmision,
      };
      const formData = new FormData();
      formData.append("datos", new Blob([JSON.stringify(dataSend)], { type: "application/json" }));
      if (data.bytesDocumento !== null) {
        formData.append("archivo", data.bytesDocumento);
      }
      callbackSaveSocio(formData);
    },
  });

  const isFormFieldValid = (name) => {
    const isValid = !!(formik.touched[name] && formik.errors[name]);
    return isValid;
  };

  const fileValidation = { isValid: true };
  const onSelectFile = (event) => {
    let file = event.files[0];
    if (file != undefined && file.type !== "application/pdf") {
      RenderToast(toast, "warn", "Información", "Solo se permiten archivos en formato de PDF");
      formik.setFieldValue("nombreDocumento", "");
      fileValidation.isValid = false;
    }
    if (fileValidation.isValid && file?.size <= 1050000) {
      formik.setFieldValue("nombreDocumento", file?.name);
      formik.setFieldValue("bytesDocumento", file);
    }
    fileValidation.isValid = true;
    fileUploadRef.current.clear();
    return fileValidation.isValid;
  };

  const onClickClose = () => {
    formik.resetForm();
    callbackModal();
  };
  return (
    <>
      <Dialog
        visible={modal}
        style={{ width: "80vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        header={socio.nemCargo ? "Registro de representante legal" : "Registro de socios"}
        modal
        resizable={false}
        onHide={onClickClose}
      >
        <Fieldset legend="Datos personales">
          <div className="grid">
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="tipoIdentificacion"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Tipo de identificación:
              </label>
              <div className="col">
                <Dropdown
                  id="tipoIdentificacion"
                  name="tipoIdentificacion"
                  optionLabel="nomCatalogo"
                  optionValue="codCatalogo"
                  placeholder="Seleccione un tipo de documento"
                  options={listaTiposIdentificacion?.object || []}
                  value={formik.values.tipoIdentificacion}
                  emptyMessage={appConstantes.SIN_DATOS}
                  className={classNames({
                    "p-invalid": isFormFieldValid("tipoIdentificacion"),
                  })}
                  disabled={deshabilitarCampos}
                  onChange={(e) => {
                    formik.handleChange(e);
                    let tipo = listaTiposIdentificacion?.object?.find(
                      (item) => item.codCatalogo === e.value,
                    );
                    formik.setFieldValue("nemonicoTipoIdentificacion", tipo?.nomNemonico ?? "");
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("tipoIdentificacion")}
              </div>
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="identificacion"
                className="mr-2"
                style={{ minWidth: "110px", textAlign: "left" }}
                required
              >
                Identificación:
              </label>
              <div className="col">
                <InputText
                  id="identificacion"
                  name="identificacion"
                  value={formik.values.identificacion}
                  placeholder="Digite su número de identificación"
                  autoComplete="off"
                  disabled={deshabilitarCampos}
                  maxLength={
                    formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA
                      ? 10
                      : 20
                  }
                  keyfilter={
                    formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA
                      ? "int"
                      : "alphanum"
                  }
                  className={classNames({
                    "p-invalid": isFormFieldValid("identificacion"),
                  })}
                  onChange={(e) => {
                    formik.setFieldValue("identificacion", e.target.value.toUpperCase());
                    if (
                      formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA &&
                      formik.values.identificacion.length > 0
                    ) {
                      formik.setFieldValue("nombre", "");
                    }
                  }}
                  onBlur={(e) => {
                    if (
                      formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA &&
                      formik.values.identificacion.length > 0
                    ) {
                      showLoader();
                      dispatch(
                        obtenerNombresFecha(
                          formik.values.nemonicoTipoIdentificacion,
                          formik.values.identificacion,
                        ),
                      );
                    }
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("identificacion")}
              </div>
            </div>
            <div className="flex col-12 md:col-12 ">
              <label
                htmlFor="capitalSocial"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Apellidos y nombres:
              </label>
              <div className="col">
                <InputText
                  id="nombre"
                  name="nombre"
                  value={formik.values.nombre}
                  autoComplete="off"
                  keyfilter={/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/}
                  placeholder="Apellidos y Nombres"
                  disabled={
                    formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA ||
                    deshabilitarCampos
                  }
                  maxLength={150}
                  className={classNames("w-full", {
                    "p-invalid": isFormFieldValid("nombre"),
                  })}
                  onChange={(e) => {
                    formik.setFieldValue("nombre", e.target.value.toUpperCase());
                  }}
                />
                {getFormErrorMessage("nombre")}
              </div>
            </div>

            {!!socio.nemCargo &&
              nemTipoSolicitud === nemonicoTipoSolicitud.CONSTITUCION &&
              formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.PASAPORTE && (
                <>
                  <div className="flex col-12 md:col-5 ">
                    <label
                      htmlFor="paisEmision"
                      className="mr-2"
                      style={{ minWidth: "110px", textAlign: "left" }}
                      required
                    >
                      País de emisión pasaporte:
                    </label>
                    <div className="col">
                      <Dropdown
                        id="paisEmision"
                        name="paisEmision"
                        optionLabel="nombre"
                        optionValue="codigo"
                        value={formik.values.paisEmision}
                        options={
                          listaPaises?.filter((item) => item.nombre.toUpperCase() !== "ECUADOR") ??
                          []
                        }
                        filter
                        emptyMessage={appConstantes.SIN_DATOS}
                        emptyFilterMessage={appConstantes.SIN_DATOS}
                        className={classNames({
                          "p-invalid": isFormFieldValid("paisEmision"),
                        })}
                        onChange={formik.handleChange}
                        style={{ width: "100%" }}
                      />
                      {getFormErrorMessage("paisEmision")}
                    </div>
                  </div>

                  <div className="flex col-12 md:col-5 ">
                    <label
                      htmlFor="tipoVisa"
                      className="mr-2"
                      style={{ minWidth: "110px", textAlign: "left" }}
                      required
                    >
                      Tipo de visa:
                    </label>
                    <div className="col">
                      <Dropdown
                        id="tipoVisa"
                        name="tipoVisa"
                        optionValue="codCatalogo"
                        optionLabel="displayLabel"
                        value={formik.values.tipoVisa}
                        options={visaOptions}
                        filter
                        emptyMessage={appConstantes.SIN_DATOS}
                        emptyFilterMessage={appConstantes.SIN_DATOS}
                        className={classNames({
                          "p-invalid": isFormFieldValid("tipoVisa"),
                        })}
                        onChange={formik.handleChange}
                        style={{ width: "100%" }}
                      />
                      {getFormErrorMessage("tipoVisa")}
                    </div>
                  </div>
                </>
              )}

            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="celular"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Celular:
              </label>
              <div className="col">
                <InputText
                  id="celular"
                  name="celular"
                  keyfilter="int"
                  maxLength={10}
                  autoComplete="off"
                  value={formik.values.celular}
                  className={classNames({
                    "p-invalid": isFormFieldValid("celular"),
                  })}
                  disabled={deshabilitarCamposRepresentante}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("celular")}
              </div>
            </div>
            <div className="flex col-12 md:col-3 ">
              <label
                htmlFor="telefono"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
              >
                Teléfono fijo:
              </label>
              <div className="col">
                <InputText
                  id="telefono"
                  name="telefono"
                  keyfilter="int"
                  maxLength={10}
                  autoComplete="off"
                  value={formik.values.telefono}
                  disabled={deshabilitarCamposRepresentante}
                  className={classNames({
                    "p-invalid": isFormFieldValid("telefono"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("telefono")}
              </div>
            </div>
            <div className="flex col-12 md:col-5 ">
              <label
                htmlFor="capitalSocial"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Correo electrónico:
              </label>
              <div className="col">
                <InputText
                  id="email"
                  name="email"
                  value={formik.values.email}
                  disabled={deshabilitarCamposRepresentante}
                  autoComplete="off"
                  maxLength={100}
                  className={classNames({
                    "p-invalid": isFormFieldValid("email"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("email")}
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="fechaNacimiento"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Fecha de nacimiento:
              </label>
              <div className="col">
                <Calendar
                  id="fechaNacimiento"
                  name="fechaNacimiento"
                  value={formik.values.fechaNacimiento}
                  onChange={formik.handleChange}
                  maxDate={new Date()}
                  dateFormat="dd/mm/yy"
                  className={classNames({
                    "p-invalid": isFormFieldValid("fechaNacimiento"),
                  })}
                  disabled={
                    (nombres?.object?.fecNacimiento != null ||
                      (formik.values.nemonicoTipoIdentificacion === nemonicoIdentificacion.CEDULA &&
                        socio.codSolConstSocios)) ??
                    false
                  }
                  readOnlyInput
                  showIcon
                  locale="es"
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("fechaNacimiento")}
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="fechaIngreso"
                className="mr-2"
                style={{ minWidth: "140px", textAlign: "left" }}
                required
              >
                Fecha de ingreso:
              </label>
              <div className="col">
                <Calendar
                  id="fechaIngreso"
                  name="fechaIngreso"
                  value={formik.values.fechaIngreso}
                  onChange={formik.handleChange}
                  dateFormat="dd/mm/yy"
                  className={classNames({
                    "p-invalid": isFormFieldValid("fechaIngreso"),
                  })}
                  showIcon
                  disabled
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("fechaIngreso")}
              </div>
            </div>
            <div className="flex col-12 md:col-4 ">
              <label
                htmlFor="capitalSocial"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
                required
              >
                Aporte :
              </label>
              <div className="col">
                <InputNumber
                  id="aporte"
                  name="aporte"
                  value={formik.values.aporte}
                  autoComplete="off"
                  useGrouping={false}
                  maxFractionDigits={2}
                  minFractionDigits={2}
                  min={0}
                  className={classNames({
                    "p-invalid": isFormFieldValid("aporte"),
                  })}
                  onValueChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("aporte")}
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="m-2"></div>
        <Fieldset legend="Domicilio">
          <div className="grid">
            <div className="col-12 md:col-5 ">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="capitalSocial"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Provincia:
                </label>
                <div className="col">
                  <Dropdown
                    id="provincia"
                    name="provincia"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formik.values.provincia}
                    options={listaProvincias}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    className={classNames({
                      "p-invalid": isFormFieldValid("provincia"),
                    })}
                    onChange={(e) => {
                      formik.setFieldValue("canton", "");
                      formik.setFieldValue("parroquia", "");
                      formik.handleChange(e);
                      showLoader();
                      dispatch(obtenerCantones(e.value));
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("provincia")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="capitalSocial"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Cantón:
                </label>
                <div className="col">
                  <Dropdown
                    id="canton"
                    name="canton"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formik.values.canton}
                    options={listaCantones}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    className={classNames({
                      "p-invalid": isFormFieldValid("canton"),
                    })}
                    onChange={(e) => {
                      formik.setFieldValue("parroquia", "");
                      formik.handleChange(e);
                      showLoader();
                      dispatch(obtenerParroquias(e.value));
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("canton")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="capitalSocial"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Parroquia:
                </label>
                <div className="col">
                  <Dropdown
                    id="parroquia"
                    name="parroquia"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formik.values.parroquia}
                    options={listaParroquias}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    className={classNames({
                      "p-invalid": isFormFieldValid("parroquia"),
                    })}
                    onChange={(e) => {
                      formik.handleChange(e);
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("parroquia")}
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="capitalSocial"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Planilla servicio básico:
                </label>
                <div className="col">
                  <FileUpload
                    id="documento"
                    name="documento"
                    ref={fileUploadRef}
                    accept=".pdf"
                    maxFileSize={1050000}
                    chooseOptions={{
                      icon: "pi pi-file",
                      className: "p-button-secondary p-button-rounded",
                    }}
                    onSelect={onSelectFile}
                    disabled={formik.values.nombreDocumento !== ""}
                    contentClassName="p-button-sm"
                    onValidationFail={(e) => {
                      formik.setFieldValue("documento", "");
                      RenderToast(
                        toast,
                        "warn",
                        "Información",
                        "El tamaño máximo del archivo es 1MB",
                      );
                    }}
                    className="p-button-sm"
                    mode="basic"
                    customUpload
                    chooseLabel="Seleccionar archivo"
                    invalidFileSizeMessageDetail={"El tamaño máximo del archivo es 1MB"}
                    style={{ size: "5px" }}
                  />
                  {formik.values.nombreDocumento === "" && getFormErrorMessage("nombreDocumento")}
                </div>
              </div>
              <div className="flex justify-content-justify">
                {formik.values.nombreDocumento !== "" && (
                  <div className="relative inline-block">
                    {formik.values.nombreDocumento}
                    <Button
                      icon="pi pi-trash"
                      rounded
                      type="button"
                      tooltip="Eliminar"
                      size="small"
                      severity="danger"
                      onClick={() => {
                        formik.setFieldValue("nombreDocumento", "");
                        formik.setFieldValue("bytesDocumento", "");
                        formik.setFieldValue("codDocuwarePlanilla", null);
                      }}
                    ></Button>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 md:col-7 ">
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Calle principal:
                </label>
                <div className="col">
                  <InputTextarea
                    id="callePrincipal"
                    name="callePrincipal"
                    value={formik.values.callePrincipal ?? ""}
                    autoComplete="off"
                    rows={2}
                    maxLength={limitSize.TEXT_INPUT}
                    className={classNames({
                      "p-invalid": isFormFieldValid("callePrincipal"),
                    })}
                    onChange={formik.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("callePrincipal")}
                  <CounterString
                    length={formik.values.callePrincipal.length}
                    maxLength={limitSize.TEXT_INPUT}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="calleSecundaria"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                  required
                >
                  Calle secundaria:
                </label>
                <div className="col">
                  <InputTextarea
                    id="calleSecundaria"
                    name="calleSecundaria"
                    value={formik.values.calleSecundaria ?? ""}
                    autoComplete="off"
                    rows={2}
                    maxLength={limitSize.TEXT_INPUT}
                    className={classNames({
                      "p-invalid": isFormFieldValid("calleSecundaria"),
                    })}
                    onChange={formik.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("calleSecundaria")}
                  <CounterString
                    length={formik.values.calleSecundaria.length}
                    maxLength={limitSize.TEXT_INPUT}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-7 ">
                <label
                  htmlFor="numero"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                >
                  Número:
                </label>
                <InputText
                  id="numero"
                  name="numero"
                  value={formik.values.numero}
                  autoComplete="off"
                  maxLength={10}
                  className={classNames({
                    "p-invalid": isFormFieldValid("numero"),
                  })}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("numero")}
              </div>
              <div className="flex col-12 md:col-12 ">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "120px", textAlign: "left" }}
                >
                  Referencia:
                </label>
                <div className="col">
                  <InputTextarea
                    id="referencia"
                    name="referencia"
                    value={formik.values.referencia ?? ""}
                    autoComplete="off"
                    rows={2}
                    maxLength={limitSize.TEXT_AREA}
                    onChange={formik.handleChange}
                    style={{ width: "100%" }}
                  />
                  <CounterString
                    length={formik.values.referencia.length}
                    maxLength={limitSize.TEXT_AREA}
                  />
                </div>
              </div>
            </div>
          </div>
        </Fieldset>

        <div className="flex pt-4 justify-content-end">
          <Button
            type="button"
            label="Cerrar"
            severity="secondary"
            outlined
            onClick={onClickClose}
            icon="pi pi-times-circle"
            className="mr-2"
          />
          <Button
            type="button"
            label="Guardar"
            onClick={formik.handleSubmit}
            icon="pi pi-save"
            className="mr-2"
          />
        </div>
      </Dialog>
    </>
  );
};
export default RegistrarSocios;
